export const meiliHost = process.env.REACT_APP_MEILI_HOST;
export const environment = process.env.REACT_APP_ENVIRONMENT ?? 'development';
